import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MasipService } from '../../services/masip.service';
import { isFormGroup } from '@angular/forms';
import { UriConfirmationDialogComponent } from '../../dialogs/uri-confirmation-dialog/uri-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-line-details',
  templateUrl: './line-details.component.html',
  styleUrl: './line-details.component.scss',
  standalone: false
})
export class LineDetailsComponent {

  @Input() deatails: boolean = false;
  @Input() line: any;
  @Output() changeDetails = new EventEmitter<boolean>();

  isEdit: boolean = false;
  isGroup: boolean = false;
  isProfile: boolean = false;
  isCustom: boolean = false;

  userFiscalId: string = '';

  selectedGroup: any;
  originalGroup: any;
  selectedProfile: any;
  originalProfile: any;

  alias: any = '';
  shortNumber: any = '';
  uri: any = '';
  lastUri: string = '';
  lastShortNumber: string = '';
  lastAlias: string = '';
  loadingApi: any;
  sim: any;
  groups: any[] = [];
  profiles: any[] = [];
  lineConfigurations: any;
  user: any;
  group: string = '';
  profile: string = '';
  idLine: any;

  groupLines: any[] = [];
  profileLines: any[] = [];
  lineSim: any;

  constructor(
    private masipService: MasipService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.loadingApi = true;
    console.log(this.line);
    if (localStorage.getItem('accessAsUser') !== null) {
      this.userFiscalId = String(localStorage.getItem('accessAsUser') || '');
    }
    // this.getLineSim();
    this.getGroups();
    this.getProfiles();
    this.getUserFiscalId();
    this.getLineConfigurations();
    this.getLineInfo();
    if (this.line.alias != null) {
      this.alias = this.line.alias;
      this.lastAlias = this.line.alias;
    }

    if (this.line.short_number != null) {

      this.shortNumber = this.line.short_number;
      this.lastShortNumber = this.line.short_number;
    }

  }


  closeDetails() {
    this.deatails = !this.deatails;
    this.changeDetails.emit(this.deatails);

  }

  editLine() {
    this.isEdit = true;
  }

  cancelEdit() {
    this.isEdit = false;

  }

  getLineInfo() {
    this.masipService.getLineInfo(this.line.telefono).subscribe(resp => {
      console.log(resp);


      if (resp.data.sim == null) {
        this.lineSim = 'Sin sim';
      } else {
        this.lineSim = resp.data.sim;
      }



    });
  }

  saveLine() {
    if (this.alias != this.lastAlias) {
      if (this.alias == '') {
        this.alias = null;
      }
      const payload = {
        phone_number: this.line.telefono,
        alias: this.alias,
      };

      this.masipService.createAlias(payload).subscribe((resp: any) => {
      },
        (error) => {
        }
      );
    }

    if (this.shortNumber != this.lastShortNumber) {
      if (this.shortNumber == '') {
        this.masipService.getShortNumber(this.line.telefono).subscribe((resp: any) => {

          this.masipService.deleteShortNumber(resp.id).subscribe((resp: any) => {
          },);
        });
      } else {
        const payload = {
          public_number: this.line.telefono,
          short_number: this.shortNumber,
          fiscal_id: this.line.fiscalId,
        };

        this.masipService.createShortNumber(payload).subscribe((resp: any) => {
        },
          (error) => {
          }
        );
      }
    }

    if (this.isGroup) {
      if (this.selectedGroup !== 'sin grupo') {
        this.groupLines.push(this.line.telefono);

        const payload = {
          phone_numbers: this.groupLines,

        };
        this.masipService.updateGroupLines(this.selectedGroup.id, payload).subscribe((resp: any) => {
        },
          (error) => {
          }
        );
      }
      if (this.selectedGroup == 'sin grupo') {

        this.groupLines = this.groupLines.filter(l => l !== this.line.telefono);

        const payload = {
          phone_numbers: this.groupLines,

        };
        this.masipService.updateGroupLines(this.originalGroup.id, payload).subscribe((resp: any) => {
        },
          (error) => {
          }
        );
      }



    }
    if (this.isProfile) {
      console.log(this.selectedProfile);
      console.log(this.profileLines);

      if (this.selectedProfile !== 'heredado') {
        this.profileLines.push(this.line.telefono);
        const payload = {
          phone_numbers: this.profileLines,
        };
        this.masipService.updateProfileLines(this.selectedProfile.id, payload).subscribe((resp: any) => {
        },
          (error) => {
          }
        );
      }
      if (this.selectedProfile == 'heredado') {
        this.profileLines = this.profileLines.filter(l => l !== this.line.telefono);
        const payload = {
          phone_numbers: this.profileLines,
        };
        this.masipService.updateProfileLines(this.originalProfile.id, payload).subscribe((resp: any) => {
        },
          (error) => {
          }
        );
      }
    }

    if (this.uri != this.lastUri) {
      const dialogRef = this.dialog.open(UriConfirmationDialogComponent, {
        width: 'fit-content',
        height: 'fit-content',
        maxWidth: '800px'
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);

        if (result == 'accepted') {
          console.log('entra');
          if (this.uri == '') {
            this.uri = null;
          }
          const payload = {
            short_number_uri: this.uri,
          };

          this.masipService.updateUser(payload, this.user.data.id).subscribe((resp: any) => {
            this.isEdit = false;
            this.closeDetails();
          },
            (error) => {
              this.isEdit = false;
              this.closeDetails();
            }
          );
        }

      });
    } else {

      this.isEdit = false;
      this.closeDetails();
    }

  }

  // getLineSim() {
  //   this.masipService.getLineSim(this.line.telefono).subscribe((resp: any) => {
  //     this.sim = resp[0];


  //   }
  //   );
  // }

  getGroups() {
    this.masipService.getGroups(this.userFiscalId).subscribe((resp: any) => {
      this.groups = resp;


    });
  }

  getProfiles() {
    this.masipService.getProfilesByUser(this.userFiscalId).subscribe((resp: any) => {
      this.profiles = resp;

    });
  }

  onGroupChange(value: string) {
    this.groupLines = [];
    this.isGroup = true;
    this.isProfile = false;
    this.isCustom = false;
    if (value !== 'sin grupo') {
      this.selectedProfile = 'heredado';
      this.selectedGroup.lines.forEach((line: any) => {
        this.groupLines.push(line.phone_number);
      });
    }
    if (value == 'sin grupo') {
      this.originalGroup.lines.forEach((line: any) => {
        this.groupLines.push(line.phone_number);
      });
    }
  }

  onProfileChange(value: string) {
    this.profileLines = [];
    this.isProfile = true;
    this.isGroup = false;
    this.isCustom = false;
    if (value !== 'heredado') {
      this.selectedGroup = 'sin grupo';
      this.selectedProfile.lines.forEach((line: any) => {
        this.profileLines.push(line.phone_number);
      });
      console.log(this.selectedProfile);

      console.log(this.profileLines);

    }

    if (value == 'heredado') {
      this.originalProfile.lines.forEach((line: any) => {
        this.profileLines.push(line.phone_number);
      });
    }

    console.log(this.isProfile);

  }

  getLineConfigurations() {
    this.masipService.getLineConfigurationInfo(this.line.telefono).subscribe((resp: any) => {
      this.lineConfigurations = resp;
      console.log(this.lineConfigurations);

      if (this.lineConfigurations.group) {
        this.group = this.lineConfigurations.group.name;
        this.selectedGroup = this.groups.find((group: any) => group.id === this.lineConfigurations.group.id);
        this.selectedGroup.lines.forEach((line: any) => {
          this.groupLines.push(line.phone_number);
        });
        console.log(this.groupLines);

        this.originalGroup = this.selectedGroup;
        this.profile = 'Heredado del grupo';
        this.isGroup = true;
        this.isCustom = false;
        this.isProfile = false;
      }
      if (this.lineConfigurations.profile) {
        this.profile = this.lineConfigurations.profile.name;
        this.selectedProfile = this.profiles.find((profile: any) => profile.id === this.lineConfigurations.profile.id);
        this.selectedProfile.lines.forEach((line: any) => {
          this.profileLines.push(line.phone_number);
        });
        this.originalProfile = this.selectedProfile;
        this.group = 'Sin grupo';
        this.isProfile = true;
        this.isGroup = false;
        this.isCustom = false;
      }
      if (this.lineConfigurations.custom == true) {
        this.profile = 'Personalizado';
        this.group = 'Sin grupo';
        this.isCustom = true;
        this.isProfile = false;
        this.isGroup = false;
      }

    });
  }

  getUserFiscalId() {
    if (localStorage.getItem('accessAsUser') !== null) {
      const fiscalId = String(localStorage.getItem('accessAsUser') || '');
      this.masipService.getUserByFiscalId(fiscalId).subscribe((resp: any) => {
        this.user = resp;
        console.log(this.user);

        if (this.user.data.short_number_uri) {
          this.uri = this.user.data.short_number_uri;
          this.lastUri = this.user.data.short_number_uri;
          console.log(this.uri);

        }
      }
      );
    }
  }
}
